/* Artboard 2b is a 520px card: one continuous rail, deliberately narrow.
   Stretching it across the shell turns a compact index into a sparse table. */
.syllabus { background: var(--paper); max-width: 620px; margin: 0 auto; }

.head { padding: 30px 32px 22px; background: var(--panel); border-bottom: 1px solid var(--ink-12); }
.title { margin: 8px 0 0; font: 300 30px/1.1 var(--serif); color: var(--ink); }
.sub { margin: 10px 0 0; font: 400 13px/1.6 var(--sans); color: var(--ink-68); }

.trail { padding: 12px 32px 34px; }

.unitRow { display: flex; align-items: center; gap: 14px; padding: 20px 0 12px; flex-wrap: wrap; }
.unitNum {
  display: flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; flex: none; border-radius: 50%;
  font: 400 13px var(--serif);
  background: var(--ink-08); color: var(--ink);
}
.unitNum.done { background: color-mix(in srgb, var(--olive) 22%, transparent); }
.unitNum.active { background: var(--accent); color: #121212; }
.unitName { font: 300 19px var(--serif); color: var(--ink); }
.unitMeta { font: 400 10px var(--mono); letter-spacing: .1em; text-transform: uppercase; color: var(--ink-45); }

.lesson {
  display: flex; align-items: center; gap: 14px; width: 100%;
  padding: 9px 8px 9px 17px; margin-left: 16px;
  border: none; border-left: 2px solid color-mix(in srgb, var(--accent) 45%, transparent);
  border-radius: 0 4px 4px 0;
  background: transparent; text-align: left; cursor: pointer;
  transition: background-color .15s ease;
}
.lesson:hover:not(.lessonLocked) { background: var(--hover); }
.lesson.lessonLocked { opacity: .5; cursor: default; border-left-color: var(--ink-12); }

.glyph {
  display: flex; align-items: center; justify-content: center;
  width: 20px; height: 20px; flex: none; border-radius: 50%;
  font: 400 10px var(--mono);
  background: var(--accent); color: #121212;
}
.glyph.done { background: color-mix(in srgb, var(--olive) 20%, transparent); color: var(--deep); }
.glyph.locked { background: var(--ink-08); color: var(--ink-45); }

.lessonTitle { flex: 1; font: 400 13px var(--sans); color: var(--ink); }
.lesson.current .lessonTitle { font-weight: 600; }
.lessonMeta { font: 400 10px var(--mono); letter-spacing: .08em; color: var(--ink-45); }

@media (max-width: 620px) {
  .head { padding: 24px 20px 20px; }
  .trail { padding: 12px 20px 28px; }
  .lessonMeta { display: none; }
}
